import React, { FC, useCallback } from "react";
import { isLinkoutSuggestion } from "stentor-guards";
import { SuggestionTypes } from "stentor-models";
import { getActionLabel } from "../../utils/getActionLabel";
import { Button } from "../Button";
import "./SuggestedAction.scss";

export interface SuggestedActionProps {
    readonly action: SuggestionTypes;
    onClick(action: SuggestionTypes): void;
    readonly className?: string;
}

export const SuggestedAction: FC<SuggestedActionProps> = props => {
    const { action, className, onClick } = props;

    const handleClick = useCallback(() => {
        onClick(action);
    }, [action, onClick])

    if (isLinkoutSuggestion(action)) {
        return (
            <span className={`xapp-search-suggested-action ${className || ""}`}>
                <a href={action.url}>{getActionLabel(action)}</a>
            </span>
        );
    } else {
        return (
            <Button
                className={`xapp-search-suggested-action ${className || ""}`}
                onClick={handleClick}
            > {getActionLabel(action)}</Button >
        );
    }
}